import styled from '@emotion/styled';
import { layers } from 'app/spacing';
import { Gradient as BaseGradient } from '__components/Kizen/ScrollFadeContainer';
import { Button as ButtonKDS } from '@kizen/kds/Button';
import css from '@emotion/css';
import {
  FLOW_BAR_HEIGHT,
  SIDEBAR_WIDTH,
  EXECUTION_MODE_HEIGHT_FRAG,
  CONTROL_BAR_HEIGHT,
} from '../ControlBar/constants';
import { KizenTypography } from '__app/typography';

const HEIGHT_OFFSET = 55;

export const HistoryWrapperPage = styled.div<{
  navHeight: number;
}>`
  width: calc(100vw - var(--app-inset-right, 0px));
  height: calc(
    100vh -
      ${({ navHeight = 51 }) =>
        navHeight + (FLOW_BAR_HEIGHT + CONTROL_BAR_HEIGHT)}px
  );
  display: flex;
`;

export const HistorySideBar = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 0 0 ${SIDEBAR_WIDTH}px;
  min-height: 1px;
  position: relative;
  padding-bottom: 30px;
  background: var(--color-background-white);
  margin-top: ${EXECUTION_MODE_HEIGHT_FRAG}px;
  padding-top: ${HEIGHT_OFFSET}px;
`;

export const HistoryButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex: 0 0 ${SIDEBAR_WIDTH}px;
  min-height: 1px;

  justify-content: space-evenly;
  align-items: center;
`;

export const HistoryButtonsWrapper = styled.div`
  background: var(--color-background-white);
  width: 100%;

  height: ${HEIGHT_OFFSET + EXECUTION_MODE_HEIGHT_FRAG}px;
  flex: 0 0 ${HEIGHT_OFFSET + EXECUTION_MODE_HEIGHT_FRAG}px;
  top: -${EXECUTION_MODE_HEIGHT_FRAG}px;
  padding: 6px 10px 0 15px;
  justify-content: start;

  display: flex;
  flex-direction: column;
  min-height: 1px;
  position: absolute;
  left: 0px;

  row-gap: 5px;

  > div {
    height: 18px;
    min-height: 18px;
  }

  div.info {
    display: flex;
    flex-direction: row;
  }
  div.title {
    justify-content: space-between;
    padding: 0;
  }

  div.close {
    display: flex;
    align-items: start;
  }

  div.buttons {
    margin: 5px 0;
    padding: 0 10px;
    width: 100%;
    display: flex;
    flex-direction: row;
    min-height: 1px;

    background: var(--color-background-white);
    justify-content: space-evenly;
    align-items: center;
  }

  z-index: 2;
`;

export const ButtonWrapper = styled.div<{ executionMode: boolean }>`
  width: ${SIDEBAR_WIDTH - 15}px;
  height: 100%;
  margin: 0 5px 10px 10px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 1px;
`;

export const LoadingWrapper = styled.div`
  animation: fadeIn linear 2s;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const ButtonCard = styled.div<{
  color: string;
  disabled: boolean;
  hoverColor: string;
}>`
  width: ${SIDEBAR_WIDTH - 25}px;

  background-color: ${({ color }) => color};
  &:hover {
    background-color: ${({ hoverColor }) => hoverColor};
  }
  ${({ disabled, hoverColor }) =>
    disabled
      ? css`
          background-color: ${hoverColor};
          &:hover {
            background-color: ${hoverColor};
          }
        `
      : css`
          cursor: pointer;
        `}
  border-radius: 5px;
  padding: 5px;

  display: flex;

  > .circle {
    flex: 50px 0 0;
  }

  > .text {
    display: flex;
    flex: 1;
    width: calc(100% - 50px);
    > .status {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    flex-direction: column;
    row-gap: 3px;
  }
`;
export const NumberWrapper = styled.div<{ color: string }>`
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
`;

export const HistoryButton = styled(ButtonKDS)`
  min-width: 100px;
`;

export const TopGradient = styled((props) => (
  <BaseGradient fadeStart={0} fadeLength={18} {...props} />
))`
  z-index: ${layers.content(0, 1)};
  top: -2px;
`;

export const BottomGradient = styled((props) => (
  <BaseGradient fadeStart={0} fadeLength={36} {...props} />
))`
  z-index: ${layers.content(0, 1)};
  bottom: -2px;
`;

export const StyledErrorLink = styled(KizenTypography)`
  color: var(--color-button-warning-default);
  :hover {
    color: var(--color-button-warning-hover);
  }
  :active {
    color: var(--color-button-warning-hover);
  }
  :focus {
    color: var(--color-button-warning-hover);
  }
`;
